import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/FactoringStore';
import './FactoringStyles.css';
import { ClipLoader } from 'react-spinners';
import { css } from 'emotion';
import InvoiceFramePDF from '../../components/InvoicePDFModal';
import { qpOpenModal, qpClosemodal } from '../../utils/misc';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const override = css`
    display: block;
    border-color: red;
`;

//const datepickerstyle = css`
//height:2.1rem;
//padding: 0.6rem 0.75rem;
//box-sizing: content-box;
//margin-top: 0px;
//box-shadow: 0 1px 0 0 #d2d2d2;
//webkit-box-shadow: 0 1px 0 0 #dd2d2d2;
//border: 1px solid #d2d2d2;
//margin-bottom: 1rem;
//display: block;
//`;

class FactoringManagement extends Component {
    constructor(props) {
        super(props);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.state = {
            tabId: "",
            isOpen: false,
            selectedInvoices: [],
            selectedAmount: 0,
            paymentMethod: 0,
            referenceNumber: "",
            paymentDate: "",
            description: "",
            FactoringId: 1,
            urlPDF: "",
            urlTIF: "",
            ShowComponentPDF: false,
            allSelected: false,
            showAlert: false,
            inputValue: "",
            tabButtonReady: true,
            tabButtonOpen: false,
            tabButtonPaid: false,

        };

        this.shouldComponentRender = this.shouldComponentRender.bind(this);
        this._handleClick = this._handleClick.bind(this);
    }
    componentDidMount() {

        const { getFactoringInvoices } = this.props;
        getFactoringInvoices();
    }
    shouldComponentRender() {
        const { isLoading } = this.props;
        if (isLoading === true) return false;

        return true;
    }
    _handleClick = (id) => {
        this.refreshSearch();
        if (id === "tabButtonReady") {
            if (this.state.tabButtonReady && !this.state.tabButtonOpen) {
                this.setState({
                    tabButtonReady: true,
                    tabButtonOpen: false,
                    tabButtonPaid: false
                })
            } else if (!this.state.tabButtonReady && this.state.tabButtonOpen) {
                this.setState({
                    tabButtonReady: true,
                    tabButtonOpen: true,
                    tabButtonPaid: false
                })
            } else if (this.state.tabButtonReady && this.state.tabButtonOpen) {
                this.setState({
                    tabButtonReady: false,
                    tabButtonOpen: true,
                    tabButtonPaid: false
                })
            }
            else {
                this.setState({
                    tabButtonReady: true,
                    tabButtonOpen: false,
                    tabButtonPaid: false
                })
            }
        } else if (id === "tabButtonOpen") {
            if (this.state.tabButtonReady && this.state.tabButtonOpen == false) {
                this.setState({
                    tabButtonReady: true,
                    tabButtonOpen: true,
                    tabButtonPaid: false
                })
            } else if (this.state.tabButtonOpen && this.state.tabButtonReady == false) {
                this.setState({
                    tabButtonReady: false,
                    tabButtonOpen: true,
                    tabButtonPaid: false
                })
            } else if (this.state.tabButtonOpen && this.state.tabButtonReady) {
                this.setState({
                    tabButtonReady: true,
                    tabButtonOpen: false,
                    tabButtonPaid: false
                })
            } else {
                this.setState({
                    tabButtonReady: false,
                    tabButtonOpen: true,
                    tabButtonPaid: false
                })
            }
        }
        else if (id === "tabButtonPaid") {
            this.setState({
                tabButtonOpen: false,
                tabButtonReady: false,
                tabButtonPaid: true
            })
        }
    }

    handleDayChange(day) {
        this.setState({ paymentDate: formatDate(day, 'L', 'en') });
    }
    downloadTIF = (number, minaylaUrl) => {
        this.setState({
            //ShowComponentPDF: true,
            urlTIF: minaylaUrl + "App/Invoice/Formattif/" + number,
        },
            () => window.open(this.state.urlTIF, "_blank"),
        )
    }
    renderIframePDF = (number, minaylaUrl) => {
        this.setState({
            ShowComponentPDF: true,
            urlPDF: minaylaUrl + "App/Invoice/Attachment/" + number + "/?notpdf=OK"
        })
    }

    removeModalData() {
        this.setState({ ShowComponentPDF: false })
    }

    _paymentMethodChange = (e) => {
        if (e.target.id == "payment-method") {
            this.setState({
                paymentMethod: parseInt(e.target.value, 10)
            })
        }
        else if (e.target.id == "reference-number") {
            this.setState({
                referenceNumber: e.target.value
            })
        }
        else if (e.target.id == "payment-date") {
            this.setState({
                paymentDate: e.target.value
            })
        }
        else if (e.target.id == "payment-date") {
            this.setState({
                paymentDate: e.target.value
            })
        }
        else if (e.target.id == "payment-note") {
            this.setState({
                description: e.target.value
            })
        }
    }

    _payClick = () => {
        if (this.state.paymentMethod === 0) {
            this.setState({ showAlert: true })
        }
        else {
            let obj = {
                Invoices: [...this.state.selectedInvoices],
                SelectedAmount: this.state.selectedAmount,
                PaymentMethodId: this.state.paymentMethod,
                ReferenceNumber: this.state.referenceNumber,
                PaymentDate: this.state.paymentDate,
                Description: this.state.description,
                FactoringId: this.state.FactoringId
            }

            this.props.paySelectedFactoringInvoices(obj).then(() => {

                const { getFactoringInvoices } = this.props;
                getFactoringInvoices().then(() => {
                    this.setState({
                        isOpen: false,
                        description: "",
                        paymentDate: "",
                        paymentMethod: 0,
                        referenceNumber: "",
                        selectedAmount: 0.0,
                        selectedInvoices: [],
                        tabId: ""
                    });
                }
                );
            });
        }
    }

    _handleChange = (invoice, event) => {
        let invoices = [...this.state.selectedInvoices]
        let selectInvsAmount = this.state.selectedAmount
        invoice["PaymentType"] = invoice.factoringStatusId != 22 ? 31 : 32
        if (event.target.checked) {
            invoice.isChecked = true
        }
        else {
            invoice.isChecked = false
        }
        if (invoices.length === 0) {
            invoices.push(invoice);
            let balance = parseFloat(invoice.totalBalance.toFixed(2));
            selectInvsAmount += balance
            let total = parseFloat(selectInvsAmount.toFixed(2));
            this.setState({
                selectedInvoices: invoices,
                selectedAmount: total
            })
        }
        else {
            let hasInvoice = invoices.includes(invoice)
            if (!hasInvoice) {
                invoices.push(invoice)
                let balance = parseFloat(invoice.totalBalance.toFixed(2));
                selectInvsAmount += balance
            }
            else {
                let index = invoices.indexOf(invoice);
                invoices.splice(index, 1);
                let balance = parseFloat(invoice.totalBalance.toFixed(2));
                selectInvsAmount -= balance
            }
            let total = parseFloat(selectInvsAmount.toFixed(2));
            this.setState({
                selectedInvoices: invoices,
                selectedAmount: total
            })
        }
    }

    documentModal(number) {
        this.props.getInvoiceDocuments(number).then(x => qpOpenModal("#inv-documents-modal"));
    }

    uploadExcel() {
        this.props.uploadExcel();
    }
    exportXML() {
        this.props.exportXML(this.state.selectedInvoices);
    }

    selectAll() {
        this.setState({
            allSelected: !this.state.allSelected
        }, () => {
            if (this.state.allSelected) {
                const { factoringInvoices } = this.props;
                let passed = [];
                if (this.state.tabButtonReady && this.state.tabButtonOpen) {
                    passed = factoringInvoices.filter(e => e.factoringStatusId === 10 || e.factoringStatusId === 22);
                }
                else if (this.state.tabButtonReady) {
                    passed = factoringInvoices.filter(e => e.factoringStatusId === 10);
                }
                else if (this.state.tabButtonOpen) {
                    passed = factoringInvoices.filter(e => e.factoringStatusId === 22);
                }

                let total = 0.0;
                passed.map(invoice => {
                    invoice.isChecked = true;
                    total += parseFloat(invoice.totalBalance);
                    let totalStr = total.toFixed(2);
                    this.setState({ selectedAmount: parseFloat(totalStr) });
                    return 0;
                });
                this.setState({ selectedInvoices: [...passed] });
            }
            else {
                this.props.factoringInvoices.map(inv => inv.isChecked = false)
                this.setState({
                    selectedAmount: 0.0,
                    selectedInvoices: []
                });
            }
        })

    }
    _openPaidModal(id) {
        this.props.viewInvoicesForTransactions(id).then(() => {
            qpOpenModal("#documents-modal");
        }).then(() => {
            const { getFactoringInvoices } = this.props;
            getFactoringInvoices();
        });
        console.log(this.props.viewInvoicesForTransactions(id))
    }
    _openClosePayModal() {
        if (!this.state.isOpen) {
            if (this.state.selectedInvoices.length === 0) {
                this.setState({ showAlert: true })
            }
            else {
                this.setState({ isOpen: true }, () => {
                    qpOpenModal("#payment-modal");
                })
            }
        }
        else {
            this.setState({ isOpen: false }, () => {
                qpClosemodal("#payment-modal");
            })
        }
    }
    updateInputValue(term) {

        this.setState({
            inputValue: term.target.value
        }, () => { this.quickSearch() },
            () => { this.quickSearch2() },
        );

    }
    quickSearch() {
        //this.searchValue = this.state.inputValue;    
        for (var i = 0; i < this.x.length; i++) {

            if (this.state.inputValue !== "") {
                if (this.x[i].invoiceNumber.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.x[i].orderNumber.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.x[i].companyName.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.x[i].totalAmount.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.x[i].totalBalance.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                ) {
                    this.x[i].displayValue = true;
                } else {
                    this.x[i].displayValue = false;
                }
            } else if (this.state.inputValue == "") {
                this.x[i].displayValue = true;
            }
        }
    }
    quickSearch2() {
        for (var i = 0; i < this.y.length; i++) {
            if (this.state.inputValue !== "") {
                if (this.y[i].factoringPaymentTransactionId.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.y[i].referenceNumber.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.y[i].methodName.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.y[i].amount.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                    || this.y[i].invoiceCount.toString().toLowerCase().includes(this.state.inputValue.toLowerCase())
                ) {
                    this.y[i].displayValue = true;
                } else {
                    this.y[i].displayValue = false;
                }
            } else if (this.state.inputValue == "") {
                this.y[i].displayValue = true;
            }
        }
    }
    refreshSearch() {
        this.state.inputValue = "";
        this.quickSearch();
        this.quickSearch2();
        document.getElementById("locSearch").value = "";
    }
    setData = () => {
        const { factoringInvoices } = this.props;
    }
    render() {
        let invs = [];
        let statusList2 = [];
        let deletedInvs = [];
        let paidTransactions = [];
        const { factoringInvoices, payTrans, statusList, deletedInvoices, isLoading, isError, minaylaUrl, documents } = this.props;
        let willpaid = 0.0;
        let openBalance = 0.0;
        let paid = 0.0;
        this.x = factoringInvoices;


        if (factoringInvoices != null && factoringInvoices != undefined) {
            invs = [...factoringInvoices];
            statusList2 = [...statusList];
            paidTransactions = [...payTrans];
            deletedInvs = [...deletedInvoices];
        }
        this.y = paidTransactions;
        for (var i = 0; i < invs.length; i++) {
            if (invs[i].factoringStatusId !== 22) {
                willpaid += invs[i].totalBalance;
                willpaid = parseFloat(willpaid.toFixed(2));
            }
            else {
                openBalance += invs[i].totalBalance;
                openBalance = parseFloat(openBalance.toFixed(2))
            }
        }
        for (var j = 0; j < paidTransactions.length; j++) {
            paid += paidTransactions[j].amount;
            paid = parseFloat(paid.toFixed(2))
        }
        if (!this.shouldComponentRender()) {
            return (
                <main className="main-content" role="main">
                    <div className='sweet-loading' style={{ textAlign: 'center', marginTop: 250 }}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={250}
                            color={'rgb(54, 215, 183)'}
                            loading={true}
                        />
                    </div>
                </main>
            );
        }

        let filteredList = [];
        if (this.x) {
            filteredList = [...this.x];
            if (this.state.tabButtonOpen && !this.state.tabButtonReady) {
                filteredList = this.x.filter(i => i.factoringStatusId === 22);
            } else if (this.state.tabButtonReady && !this.state.tabButtonOpen) {
                filteredList = this.x.filter(i => i.factoringStatusId === 10);
            }
        }


        return (
            <main className="main-content p-5" role="main">
                <div className="container-fluid d-flex justify-content-center mb-5 pb-5">
                    <div className="col-lg-10" style={{ marginTop: "30px" }}>
                        <div className="d-flex justify-content-between align-items-center pb-4 mt-3">
                            <div className="d-flex">
                                <button type="button" className="btn btn-primary icon-btn mr-2" data-toggle="tooltip" data-placement="top" title="Export to XML" onClick={() => this.exportXML()} disabled={this.state.selectedInvoices.length === 0} ><FontAwesomeIcon icon="file-code" size="2x" /></button>
                                <button type="button" className="btn btn-primary icon-btn mr-2" data-toggle="tooltip" data-placement="top" title="Export to EXCEL" onClick={() => this.uploadExcel()} ><FontAwesomeIcon icon="file-excel" size="2x" /></button>
                                <button type="button" id="pay-btn" className="btn btn-success icon-btn mr-2" data-toggle="tooltip" data-placement="top" title="Pay" disabled={this.state.selectedInvoices.length === 0} onClick={() => this._openClosePayModal()}><FontAwesomeIcon icon="money-check" size="2x" disabled={this.state.selectedInvoices.length === 0} /></button>
                                <span style={{ fontWeight: "bold", marginLeft: "5px" }}>Selected Amount:<br /><span className="amountClass" id="selectedAmount">$ {this.state.selectedAmount > 0 ? this.state.selectedAmount : 0}</span></span>
                            </div>
                            <div className="d-flex">
                                <div className="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group" role="group" aria-label="First group">
                                        <button type="button" name="tabButtonReady" className={this.state.tabButtonReady ? "btn btn-light waves-effect waves-light active" : "btn btn-light waves-effect waves-light"} id="tabButtonReady" onClick={() => this._handleClick('tabButtonReady')}>
                                            <span data-id="1" className="btnText">Ready to Factor</span>
                                            <br />
                                            <span className="tabButtonAmount" id="spanReadyToFactorAmount" data-id="4">$ {willpaid}</span>
                                        </button>
                                        <button type="button" name="tabButtonOpen" className={this.state.tabButtonOpen ? "btn btn-light waves-effect waves-light active" : "btn btn-light waves-effect waves-light"} id="tabButtonOpen" onClick={() => this._handleClick('tabButtonOpen')}>
                                            <span data-id="2" className="btnText">Factor Open Balance</span>
                                            <br />
                                            <span className="tabButtonAmount" id="spanFactorOpenBalanceAmount" data-id="5">$ {openBalance}</span>
                                        </button>
                                        <button type="button" name="tabButtonPaid" className={this.state.tabButtonPaid ? "btn btn-light waves-effect waves-light active" : "btn btn-light waves-effect waves-light"} id="tabButtonPaid" onClick={() => this._handleClick('tabButtonPaid')}>
                                            <span data-id="3" className="btnText">Payment Transactions</span>
                                            <br />
                                            <span className="tabButtonAmount" id="spanPaymentTransactionsAmount" data-id="6">${paid}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center" style={{ marginTop: "10px" }}>
                                <input type="text" className="form-control form-control-sm mt-2" id="locSearch" onChange={term => this.updateInputValue(term)} value={this.searchValue} placeholder="Quick Search.." aria-label="Search locations" autofill="off" autoComplete="off" aria-describedby="basic-addon2" />
                            </div>
                        </div>
                        <div className="d-flex card justify-content-between align-items-center mt-3 mb-3" style={{ height: "auto" }}>
                            <table className="table table-striped table-hover" id="currentTable" style={this.state.tabButtonReady || this.state.tabButtonOpen ? { width: "100%", marginBottom: '0px !important' } : { width: "100%", marginBottom: '0px !important', display: "none" }}>
                                <thead className="thead-customer">
                                    <tr style={{ height: "75px" }}>
                                        <th className="thStyle">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" checked={this.state.allSelected} onClick={() => this.selectAll()} id="currentSelectAll" />
                                                <label className="custom-control-label" htmlFor="currentSelectAll"></label>
                                            </div>
                                        </th>
                                        <th className="thStyle">Invoice #</th>
                                        <th className="thStyle">Total Amount</th>
                                        <th className="thStyle">Balance</th>
                                        <th className="thStyle">Invoice Date</th>
                                        <th className="thStyle">Due Date</th>
                                        <th className="thStyle">Order #</th>
                                        <th className="thStyle">Company</th>
                                        <th className="thStyle">Email Sent</th>
                                        <th className="thStyle">Fact. Status</th>
                                        <th className="thStyle">Actions</th>
                                    </tr>
                                </thead>
                                <tbody id="currentAppendTbody">
                                    {


                                        filteredList.map((inv, index) => {

                                            var status = statusList2.filter(obj => {
                                                return obj.statusLookUpId === inv.factoringStatusId
                                            });


                                            var difference = inv.totalAmount - inv.oldInvoiceAmount;
                                            this.quickSearch();
                                            return (
                                                <tr className="currentTableRow" key={index} style={inv.displayValue ? { display: "" } : { display: "none" }}>
                                                    <td className="tdStyle">
                                                        <div className="custom-control custom-checkbox">
                                                            <input checked={(inv.isChecked !== undefined && inv.isChecked)} type="checkbox" onChange={(e) => this._handleChange(inv, e)} className="custom-control-input" id={"select_" + inv.invoiceNumber} />
                                                            <label className="custom-control-label" htmlFor={"select_" + inv.invoiceNumber}></label>
                                                        </div>
                                                    </td>
                                                    <td className="tdStyle"><a style={{ fontWeight: 700 }} data-toggle="modal" data-target="#frameModal2" onClick={() => this.renderIframePDF(inv.invoiceNumber, minaylaUrl)}>{inv.invoiceNumber} </a>  </td>
                                                    <td className="tdStyle"> {inv.totalAmount} {difference !== 0 ? <span className='badge badge-danger'>{inv.oldInvoiceAmount}</span> : null} </td>
                                                    <td className="tdStyle"> {inv.totalBalance} </td>
                                                    <td className="tdStyle"> {inv.generationDate} </td>
                                                    <td className="tdStyle"> {inv.dueDate} </td>
                                                    <td className="tdStyle"> {inv.orderNumber} </td>
                                                    <td className="tdStyle"> {inv.companyName} </td>
                                                    <td className="tdStyle"> {inv.isSent != null && inv.isSent !== false ? <i className="batch-icon batch-icon-tick text-success"></i> : <i className="batch-icon batch-icon-cross text-danger"></i>}</td>
                                                    <td className="tdStyle"> {status[0].statusLookUpId === 22 ? <span className="badge badge-warning">Open Balance</span> : <span className="badge badge-primary">Ready to Factor</span>
                                                    }
                                                    </td>
                                                    <td className="tdStyle">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            data-flip="false"
                                                        >
                                                            <i className="batch-icon batch-icon-ellipsis"></i>
                                                        </button>
                                                        <div
                                                            className="dropdown-menu dropdown-menu-right"
                                                            aria-labelledby="reply-mail-dropdown"
                                                        >
                                                            <a className="dropdown-item" onClick={() => this.documentModal(inv.invoiceNumber)}>
                                                                <i className="batch-icon batch-icon-document" />
                                                                Documents
                                                            </a>
                                                            <a className="dropdown-item" onClick={() => this.downloadTIF(inv.invoiceNumber, minaylaUrl)} >

                                                                <i className="batch-icon batch-icon-image" />
                                                                DOWNLOAD AS TIF IMAGE
                                                            </a>


                                                        </div>
                                                    </td>
                                                </tr>

                                            );
                                        })
                                    }

                                    {
                                        //deletedInvs.map((inv, index) => {
                                        //    if (this.state.tabId === "tabButtonOpen" && inv.factoringStatusId !== 22 ) {
                                        //        return null;
                                        //    }
                                        //    var status = statusList2.filter(obj => {
                                        //        return obj.statusLookUpId === inv.factoringStatusId
                                        //    });
                                        //    var difference = inv.totalAmount - inv.oldInvoiceAmount;
                                        //    if (this.state.tabId === "tabButtonReady" && status[0].statusLookUpId === 22 ) {
                                        //        return null
                                        //    }
                                        //        return (
                                        //            <tr className="currentTableRow" key={index}>
                                        //                <td className="tdStyle">
                                        //                    <div className="custom-control custom-checkbox">
                                        //                        <input type="checkbox" onChange={(e) => this._handleChange(inv, e)} className="custom-control-input" id={"select_" + inv.invoiceNumber} />
                                        //                        <label className="custom-control-label" htmlFor={"select_" + inv.invoiceNumber}></label>
                                        //                    </div>
                                        //                </td>
                                        //                <td className="tdStyle"> {inv.invoiceNumber === 0 ? "Removed" : null} </td>
                                        //                <td className="tdStyle"> {inv.totalAmount} {difference !== 0 ? <span className='badge badge-danger'>- {inv.oldInvoiceAmount}</span> : null} </td>
                                        //                <td className="tdStyle"> {inv.totalBalance} </td>
                                        //                <td className="tdStyle"> {inv.generationDate} </td>
                                        //                <td className="tdStyle"> {inv.dueDate} </td>
                                        //                <td className="tdStyle"> {inv.orderNumber} </td>
                                        //                <td className="tdStyle"> {inv.companyName} </td>
                                        //                <td className="tdStyle"> {inv.isSent != null && inv.isSent !== false ? <i className="batch-icon batch-icon-tick text-success"></i> : <i className="batch-icon batch-icon-cross text-danger"></i>}</td>
                                        //                <td className="tdStyle"> {status[0].statusLookUpId === 22 ? <span className="badge badge-warning">Open Balance</span> : <span className="badge badge-primary">Ready to Factor</span>
                                        //                }
                                        //                </td>
                                        //                <td className="tdStyle">
                                        //                    <button
                                        //                        type="button"
                                        //                        className="btn btn-link"
                                        //                        data-toggle="dropdown"
                                        //                        aria-haspopup="true"
                                        //                        aria-expanded="false"
                                        //                        data-flip="false"
                                        //                    >
                                        //                        <i className="batch-icon batch-icon-ellipsis"></i>
                                        //                    </button>
                                        //                    <div
                                        //                        className="dropdown-menu dropdown-menu-right"
                                        //                        aria-labelledby="reply-mail-dropdown"
                                        //                    >
                                        //                        <a className="dropdown-item">
                                        //                            <i className="batch-icon batch-icon-document" />
                                        //                            Documents
                                        //                    </a>                                                               
                                        //                        <a className="dropdown-item" onClick={() => this.downloadTIF(inv.invoiceNumber, minaylaUrl)} >

                                        //                            <i className="batch-icon batch-icon-document" />
                                        //                            Download as TIF image
                                        //                    </a>
                                        //                    </div>
                                        //                </td>
                                        //            </tr>
                                        //        );
                                        //})
                                    }
                                </tbody>
                            </table>

                            <table className="table table-striped table-hover" id="paidTable" style={this.state.tabButtonPaid ? { width: "100%", marginBottom: '0px !important' } : { width: "100%", marginBottom: '0px !important', display: "none" }}>
                                <thead className="thead-customer">
                                    <tr style={{ height: "75px" }}>
                                        <th className="thStyle">Transaction ID #</th>
                                        <th className="thStyle">Invoice Count</th>
                                        <th className="thStyle">Reference Number</th>
                                        <th className="thStyle">Method Name</th>
                                        <th className="thStyle">Amount</th>
                                        <th className="thStyle">Payment Date</th>
                                        <th className="thStyle">Description</th>
                                        <th className="thStyle">Action</th>
                                    </tr>
                                </thead>
                                <tbody id="paidAppendTbody">
                                    {
                                        this.y.map((inv, index) => {

                                            this.quickSearch2();
                                            return (
                                                <tr className="currentTableRow" key={index} style={inv.displayValue ? { display: "" } : { display: "none" }}>
                                                    <td className="tdStyle"># {inv.factoringPaymentTransactionId} </td>
                                                    <td className="tdStyle"> {inv.invoiceCount} </td>
                                                    <td className="tdStyle"> {inv.referenceNumber} </td>
                                                    <td className="tdStyle"> {inv.methodName} </td>
                                                    <td className="tdStyle">$ {inv.amount} </td>
                                                    <td className="tdStyle"> {inv.paymentDate} </td>
                                                    <td className="tdStyle"> {inv.description} </td>
                                                    <td className="tdStyle">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                            data-flip="false"
                                                        >
                                                            <i className="batch-icon batch-icon-ellipsis"></i>
                                                        </button>
                                                        <div
                                                            className="dropdown-menu dropdown-menu-right"
                                                            aria-labelledby="reply-mail-dropdown"
                                                        >
                                                            <a className="dropdown-item" key={index} data-toggle="modal" onClick={() => this._openPaidModal(inv.factoringPaymentTransactionId)}>
                                                                <i className="batch-icon batch-icon-document" />
                                                                Details
                                                      </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="modal fade"
                    id="payment-modal"
                    style={!this.state.isOpen ? { display: 'none' } : { display: 'block' }}
                    tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header mb-4" style={{ borderBottom: "1px solid #D8D8D8" }}>
                                <h5 className="modal-title"><i style={{ color: "#4285F4" }} className="fas fa-coins fa-lg"></i>&nbsp; Make Payment</h5>
                                <button type="button" className="close" onClick={() => this._openClosePayModal()} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="row m-0 mb-4 pl-4">
                                <div className="col-12 m-0 mb-4">
                                    <div className="form-group row">
                                        <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Payment Method</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" id="payment-method" onChange={this._paymentMethodChange.bind(this)}>
                                                <option value="0">Select Payment Method </option>
                                                <option value="2">Wire Transfer</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Amount</label>
                                        <div className="col-sm-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input type="text" className="form-control" id="selectedTotalBalance" value={this.state.selectedAmount} readOnly="true" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Payment Date</label>
                                        <div className="col-sm-6">
                                            <DayPickerInput
                                                formatDate={formatDate}
                                                format="L"
                                                parseDate={parseDate}
                                                placeholder={`${formatDate(new Date(), 'L', 'en')}`}
                                                onDayChange={this.handleDayChange}
                                                inputProps={{ className: 'form-control', type: 'text', style: { width: 344 } }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Reference Number</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" id="reference-number" placeholder="Check/Payment Number"
                                                onChange={this._paymentMethodChange.bind(this)} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Payment Note</label>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" id="payment-note" rows="2" placeholder="Type here.." onChange={this._paymentMethodChange.bind(this)}></textarea>
                                        </div>
                                    </div>
                                    <div className="row d-flex justify-content-center">
                                        <span id="selectedInvoiceCount"><strong>{this.state.selectedInvoices.length}</strong></span><span><strong>&nbsp; invoice selected.</strong></span>
                                    </div>
                                </div>
                            </div>

                            <div className="row m-0 p-4 form-group d-flex justify-content-center" style={{ borderTop: "1px solid #D8D8D8" }}>
                                <button type="button" className="btn btn-success waves-effect waves-light btn-lg" onClick={() => { this._payClick() }}>PAY</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade"
                    id="frameModal2"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5
                                    className="modal-title"
                                    id="exampleModalLabel"
                                >
                                    INVOICE PDF
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => this.removeModalData()}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">{(this.state.ShowComponentPDF) && <InvoiceFramePDF modalShowPDF={this.state.ShowComponentPDF} src={this.state.urlPDF} width={"100%"} height={700} />}</div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={() => this.removeModalData()}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="documents-modal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header mb-4" style={{ borderBottom: "1px solid #D8D8D8" }}>
                                <h5 className="modal-title" ><i style={{ color: "#4285F4" }} className="fas fa-file-alt fa-lg"></i>&nbsp; <label id="lblViewDocumentModalTitle">Documents</label></h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="row m-0 mb-4 pl-4">
                                <div className="col-12 m-0 mb-4" id="appendDocumentsDiv">
                                    <div className="row" style={{ paddingRight: "20px" }}>
                                        <div className='col-3'><b>Invoice Number</b></div>
                                        <div className='col-3'><b>DO</b></div>
                                        <div className='col-3'><b>Payment Amount</b></div>
                                        <div className='col-3'><b>Commission</b></div>
                                        <div className='col-12'>
                                            {
                                                this.props.paidInvoices !== undefined ? this.props.paidInvoices.map((inv, index) => {
                                                    return (
                                                        <div key={index} className='row' style={{ border: "1px solid #dcdcdc", padding: "5px" }}>
                                                            <div className='col-3'> {inv.invoiceNumber}</div>
                                                            <div className='col-3'> {inv.orderNumber}</div>
                                                            <div className='col-3'>$ {inv.paymentAmount} </div>
                                                            <div className='col-3'>$ {inv.commission} </div>
                                                        </div>
                                                    );
                                                }) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="inv-documents-modal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header mb-4" style={{ borderBottom: "1px solid #D8D8D8" }}>
                                <h5 className="modal-title" ><i style={{ color: "#4285F4" }} className="fas fa-file-alt fa-lg"></i>&nbsp; <label id="lblViewDocumentModalTitle">Documents</label></h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="row m-0 mb-4 pl-4">
                                <div className="col-12 m-0 mb-4" id="appendDocumentsDiv">
                                    <div className="row" style={{ paddingRight: "20px" }}>

                                        <div className='col-12'>
                                            {
                                                documents !== undefined ?
                                                    (documents.length === 0 ?
                                                        <p>Not Found</p> : documents.map((inv, index) => {
                                                            return (
                                                                <div key={index} className='row' style={{ border: "1px solid #dcdcdc", padding: "5px" }}>
                                                                    <Link to="chart" target="_blank" to={this.props.minaylaUrl + "app/api/v1/dispatching/retrievepod/" + inv.docId} >{inv.fileName}</Link>
                                                                </div>
                                                            );
                                                        })
                                                    )
                                                    : <p>Not Found</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             
            </main>
        );
    }
}
export default connect(
    state => state.factoringData,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(FactoringManagement)


// WEBPACK FOOTER //
// ./src/view/Factoring/FactoringManagement.js